module.exports = __webpack_public_path__ + "img/8.a0345513.png";